window.Facedr = window.Facedr || {};
window.Facedr.Filter = function() {
  var $filter = $('[data-topic]');

  $filter.click(function() {
    var topic = $(this).data('topic');
    $('[data-topic]').removeClass('active');
    $('[data-faq-search]').val('');
    $(this).addClass('active');
    if (topic === 'all') {
      $('.accordion__item').show();
    } else {
      $('.accordion__item').hide();
      $('[data-' + topic + ']').show();
    }
  });
};
